import { render, staticRenderFns } from "./IdleModal.vue?vue&type=template&id=24788f3a"
import script from "./IdleModal.vue?vue&type=script&lang=js"
export * from "./IdleModal.vue?vue&type=script&lang=js"
import style0 from "./IdleModal.vue?vue&type=style&index=0&id=24788f3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports